const accessAuth = {
    HOMESECOND: {
        path: '/'
    },
    HOME: {
        path: '/home'
    },
    LOGIN: {
        path: '/login'
    },
    PROFILE_PAGE: {
        path: '/profile/:id'
    },
    PRIVACY_POLICY: {
        path: '/privacy-policy'
    },
    TERMS_CONDITIONS: {
        path: '/terms-and-conditions'
    },
    RETURN_REFUND_POLICY: {
        path: '/return-and-refund-policy'
    },

    UNKNOWN_PATH: {
        path: '*'
    }

}

export default accessAuth;